import { Outlet } from 'react-router'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'
import { lazy } from '~/router/lazy'
import { RouteObject } from '~/router/types'

const OT = BreadcrumbObjectType

export const tableRoute: RouteObject = {
  path: 'table/:table_id',
  Component: Outlet,
  handle: { objectType: OT.TABLE },
  children: [
    {
      index: true,
      lazy: lazy(() => import('./TableControllerComponent')),
      handle: {
        pageType: 'table',
        showActivityFeed: true,
        objectType: OT.TABLE,
      },
    },
    {
      path: 'settings',
      lazy: lazy(() => import('../table-settings/TableSettingsControllerComponent')),
      handle: {
        pageType: 'tableSettings',
        crumb: 'title_bar.table_settings',
        showLeftNav: false,
        showBackLink: true,
        objectType: OT.TABLE,
      },
    },
    {
      path: 'exports',
      lazy: lazy(() => import('../table-settings/TableSettingsExports')),
      handle: {
        crumb: 'title_bar.table_exports',
        showLeftNav: false,
        showBackLink: true,
        objectType: OT.TABLE,
      },
    },
  ],
}
